import axios from 'axios';
import { isDev } from '../util/isDev';
declare module 'axios' {
  export interface AxiosRequestConfig {
    crossDomain?: boolean;
  }
}

export async function fetchManifest(): Promise<string> {
  let manifestUrl = '//web.deputy.com/kiosk/stable/manifest.json';
  if (isDev() || location.hostname.includes('deputec.com')) {
    manifestUrl = '//web.test.dpty.io/kiosk/stable/manifest.json';
  }
  const { data } = await axios.get(manifestUrl, {
    crossDomain: true,
  });

  return data['src/main.ts'].file;
}
